import React from 'react';

import StatusIcon, { StatusIconTypes } from 'common/components/core/StatusIcon/StatusIcon';
import { NotificationSeverity } from 'common/components/NotificationsWidget/queries';

export function NotificationStatusIcon({ severity }: { severity?: NotificationSeverity }) {
  if (severity === NotificationSeverity.ERROR) {
    return <StatusIcon type={StatusIconTypes.ALERT} />;
  }
  if (severity === NotificationSeverity.WARNING) {
    return <StatusIcon type={StatusIconTypes.WARNING} />;
  }
  return <StatusIcon type={StatusIconTypes.INFO} />;
}
